<template>
  <v-container id="bo">
    <v-container id="home_card" >

      <center>
        <h1>XSINT Reveal the Unseen</h1>
        <br>
        <h2>Enhance your OSINT investigations with XSINT Intelligence.</h2>
        <br><br>
        <button class="main-btn" @click="navigate">I want to try</button>

        <div class="saut-1"></div>
          
        <a href="#features"  >
          <svg style="width: 50px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[24px] h-[24px] animate-bounce">
            <title>Scroll down</title>
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </a>

        <div style="height:20vh"></div>

        <div id="features" style="height:15vh"></div>

        <h1 class="hhh" >Powerful new features <br>to find informations </h1>
        <div class="saut-2"></div>

        <v-row>
        <v-col 
          v-for="(card, index) in cards" 
          :key="index" 
          cols="12" 
          sm="6" 
          md="4"
        >
          <v-card class="pa-4 home_c_card" raised>
            <!-- Icône en haut de la carte -->
            <v-icon class="icon-large" size="50">{{ card.icon }}</v-icon>
            <v-card-title><b>{{ card.title }}</b></v-card-title>
            <v-card-subtitle>{{ card.subtitle }}</v-card-subtitle>
            <v-card-text>
              {{ card.description }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <br><br>

      <button class="main-btn-2" @click="navigate2">More Informations</button>

        <div class="saut-3"></div>
        <div style="" id="pricing"></div>
        <Pricing />

      </center>
    </v-container>
  </v-container>
</template>

<style scoped>

.saut-1{
  height:10vh;
}

.saut-2{
  height:4vh
}

.saut-3{
  height:5vh
}

.home_c_card{
  background-color: rgba(92, 92, 92, 0.103);
}

.home_c_card:hover{
  transition: 1s;
  background-color: rgba(4, 0, 255, 0.096);
}

.hhh{
  font-size: 25px;
  color: white;
  font-family: Inter, sans-serif;
}

.main-btn {
  padding: 10px;
  background-color: rgba(0, 119, 255, 0.89);
  border-radius: 10px;
  font-size: 20px;
  color: white;
  border: none;
  cursor: pointer;
  transition: transform 0.3s ease-in-out; 
  animation: resizeBtn 5s ease-in-out infinite; 
}

.main-btn-2 {
  padding: 8px;
  background-color:  rgba(0, 119, 255, 0.89);
  border-radius: 10px;
  font-size: 18px;
  color: white;
  border: none;
  cursor: pointer;

}

@keyframes resizeBtn {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

h1 {
  font-size: 45px;
  color: white;
  font-family: Inter, sans-serif;
}

h2 {
  font-size: 25px;
  color: rgb(187, 187, 187);
  font-family: Inter, sans-serif;
}

#home_card {
  margin-top: 25%;
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .saut-3{
    height:81vh
  }
  #home_card {
    margin-top: 12%;
    width: 85%;
  }

  .hhh{
    font-size: 65px;
    color: white;
    font-family: Inter, sans-serif;
  }


  h1 {
    font-size: 85px;
    color: white;
    font-family: Inter, sans-serif;
  }

  h2 {
    font-size: 25px;
    color: rgb(187, 187, 187);
    font-family: Inter, sans-serif;
  }

  .saut-1{
    height:20vh;
  }

  .saut-2{
    height:5vh
  }


.v-card {
  height: 245px; /* Fixe une hauteur uniforme pour chaque carte */
}



}

/* Taille plus grande pour l'icône */
.icon-large {
  font-size: 50px; /* Ajustez la taille de l'icône ici */
  color: rgba(0, 119, 255, 0.89); /* Optionnel : changer la couleur de l'icône */
  margin-bottom: 20px; /* Espacement entre l'icône et le titre */
}


</style>

<script setup>
import { ref } from 'vue';
import Pricing from './pricing_page.vue'; 
import { useHead } from '@vueuse/head';

useHead({
  title: 'XSINT Intelligence | The Most Powerful OSINT Tool for Investigations',
  meta: [
    { name: 'keywords', content: 'OSINT, XSINT, osint tool, investigations, email lookup, phone lookup, IP lookup, data breach search, intelligence gathering, XSINT Intelligence, investigation tools' },
    { property: 'og:title', content: 'XSINT Intelligence | The Most Powerful OSINT Tool for Investigations' },
    { name: 'twitter:title', content: 'XSINT Intelligence | The Most Powerful OSINT Tool for Investigations' },
    { name: 'description', content: 'XSINT is a leading OSINT tool designed to enhance your investigations by providing powerful search capabilities across emails, phone numbers, IP addresses, and more.' },
    { name: 'twitter:description', content: 'Discover XSINT, the top OSINT tool that enhances your investigations with advanced search for emails, phone numbers, IP addresses, and more.' },
    { property: 'og:description', content: 'XSINT is a top OSINT tool that boosts investigations with advanced search features for emails, phone numbers, IP addresses, and other critical data.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.xsint-intelligence.com/' },
    { property: 'og:image', content: 'https://www.xsint-intelligence.com/images/og-image.jpg' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: 'https://www.xsint-intelligence.com/images/twitter-card-image.jpg' }, 
    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'XSINT Intelligence' }
  ]
});

const cards = ref([
  {
    title: "Email Lookup",
    icon: "mdi-email",
    description: "Discover whether an email has been exposed in data breaches and gain insights into related accounts."
  },
  {
    title: "IP Address Tracking",
    icon: "mdi-ip-network",
    description: "Analyze IP addresses and locate their origins while ensuring full confidentiality and precision."
  },
  {
    title: "Phone Number Search",
    icon: "mdi-phone",
    description: "Investigate phone numbers across breach databases to uncover related accounts and activity."
  },
]);


</script>

<script>
export default {
    data(){
        return {
          isAuthentified: localStorage.getItem('Authorization') !== null,
          petit: false,
        };
    },
    created() {
      this.petit = window.innerWidth < 1180;
      if (localStorage.getItem('Authorization') && window.location.hash !== '#pricing') {
        this.$router.push('/lookup'); // Redirige vers /update si l'utilisateur est inscrit
      }
    },

    methods: {
      navigate() {
        this.$router.push('/lookup');
      },
      navigate2() {
        window.location = "/features";
      }
    }
}

</script>
